import React from 'react'

export default function Loader() {
    require("./loader.css");
  return (
    <section className="loader-cont">
        <h4 className="loader">Gl<span></span>ryMix</h4>
    </section>
  )
}
